export default __webpack_public_path__ + "static/media/swoosh.39bf7aab.mp3";